import { h } from 'preact';
import Store from 'store/store';
import { applyPatch } from 'fast-json-patch';
import * as jsonPointer from 'utils/jsonPointer';
import { Modal, showModal } from 'utils/modal';

import Button from 'components/button/button';

import s from 'utils/conflictResolutionModal.sss';

// NOTE: Should we change our JSON patch lib to https://github.com/benjamine/jsondiffpatch ?
//   it is ~10x slower but handles "move" better, e.g. for array reordering (and performance might not matter too much)
export class ConflictResolutionModal extends Modal {
	s = s;

	title = 'Resolve conflicts';

	getRemoteValue(conflict) {
		let value = '';
		let classes = [];
		if (conflict.op === 'remove') {
			classes.push(s.removed);
		} else {
			value = conflict.value;
			classes = [];
			if (typeof value === 'object') {
				// value = JSON.stringify(value, null, '    ');
				value = '(item)';
				classes.push(s.object);
			}
		}
		return <td class={classes}>{value}</td>;
	}

	getCurrentValue(conflict) {
		let classes = [];
		let value = jsonPointer.get(this.props.currentData, conflict.path);
		if (typeof value === 'object') {
			// value = JSON.stringify(value, null, '    ');
			value = '(item)';
			classes.push(s.object);
		}
		if (value === undefined) classes.push(s.removed);
		return <td class={classes}>{value}</td>;
	}

	renderContent() {
		const { conflicts } = this.props;
		return (
			<p class={this.c('content')}>
				Your changes conflict with someone else's recent changes. Which versions do you want to keep?
				<details>
					<summary>{`${conflicts.length} conflicting change${conflicts.length === 1 ? '' : 's'}`}</summary>
					<table>
						<thead>
							<tr>
								<th>Their change</th>
								<th>Your change</th>
							</tr>
						</thead>
						<tbody>
							{conflicts.map((conflict) => (
								<tr>
									{this.getRemoteValue(conflict)}
									{this.getCurrentValue(conflict)}
								</tr>
							))}
						</tbody>
					</table>
				</details>
			</p>
		);
	}

	renderActions() {
		return (
			<div class={this.c('actions')}>
				<Button type="submit" value="CANCEL">Cancel</Button>
				<Button type="submit" value="REMOTE">Keep their changes</Button>
				<Button primary type="submit" value="SELF">Keep your changes</Button>
			</div>
		);
	}
}

export async function handleConflicts(path) {
	const data = jsonPointer.get(Store.get().data, path)?.toJS();
	if (!data?.conflicts?.length) {
		return;
	}
	const saved = jsonPointer.get(Store.get().savedData, path);
	const result = await showModal(ConflictResolutionModal, { conflicts: data.conflicts, remoteData: saved.content, currentData: data.content });
	if (result === 'CANCEL') {
		return 'CANCEL';
	}
	if (result === 'REMOTE') {
		applyPatch(data.content, data.conflicts);
		jsonPointer.set(Store.get().data, jsonPointer.parse(path).concat('content'), data.content).now();
	}
	return true;
}